export function Sinnoh(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 48 48"
      {...props}
    >
      {}
      <g fill="none" stroke="currentColor" strokeWidth="4">
        <path strokeLinecap="round" strokeLinejoin="round" d="M4 44h40" />
        <path strokeLinejoin="round" d="M8 8.364L24 4l16 4.364V14H8z" />
        <path
          strokeLinecap="round"
          d="M10 14v24m7-24v24m7-24v24m7-24v24m7-24v24"
        />
        <path strokeLinejoin="round" d="M7 38h34v6H7z" />
      </g>
    </svg>
  );
}
